import { App, defineCustomElement } from 'vue'
import { createPinia } from 'pinia'

// app plugins
import PrimeVue from 'primevue/config';
import FloatingVue from 'floating-vue';

// app plugin styles
import 'floating-vue/dist/style.css';

// main components
import EntriesApp from './AppEntries.vue';
import FiltersApp from './AppFilters.vue';
import PaginationApp from './AppPagination.vue';

// vue app config
const pinia = createPinia();
const primeVueConfig = {
  theme: "none"
}
const customApp = (app: App) => {
  app.use(pinia);
  app.use(PrimeVue, primeVueConfig);
  app.use(FloatingVue);
};

// declare as custom element
const entriesElem = defineCustomElement(EntriesApp, { configureApp: customApp, shadowRoot: false });
const filterElem = defineCustomElement(FiltersApp, { configureApp: customApp, shadowRoot: false });
const paginationElem = defineCustomElement(PaginationApp, { configureApp: customApp, shadowRoot: false });

// register custom elements
customElements.define('fw-filterpel-entries', entriesElem);
customElements.define('fw-filterpel-filters', filterElem);
customElements.define('fw-filterpel-pagination', paginationElem);
